import { createApp } from 'vue';
import 'mapbox-gl/dist/mapbox-gl.css';
import './styles/base.css';
import App from './App.vue';
import { router } from './router';
import { installAnalytics } from './analytics';

installAnalytics(router);

createApp(App).use(router).mount('#app');
